'use client';

import { Button } from 'flowbite-react';
import type { FunctionComponent } from 'react';

import type { IconButtonProps } from './types';

const buttonVariants = {
  primary: 'border-brand',
  secondary: 'border-card_dark dark:border-white',
  tertiary: '!border-none'
};

const buttonSizes = {
  large: 'p-3',
  medium: 'p-2.5',
  small: 'p-2'
};

const customTheme = {
  base: '',
  size: {},
  disabled: 'cursor-not-allowed opacity-30'
};

export const IconButton: FunctionComponent<IconButtonProps> = ({
  icon,
  onClick,
  variant = 'tertiary',
  sizing = 'medium',
  className = '',
  ...props
}) => {
  const buttonClasses = `flex items-center justify-center w-fit rounded-full bg-transparent border focus:ring-0 focus:ring-transparent ${buttonVariants[variant]} ${buttonSizes[sizing]} ${className}`;

  return (
    <Button {...props} size={sizing} theme={customTheme} onClick={onClick} className={buttonClasses}>
      {icon}
    </Button>
  );
};
